<template lang="pug">
    div
        div.ratingWrapper

            v-rating(
                v-model="rating"
                color="white"
                size="44"
            )

        // Rating error message
        div.ratingError(v-if="showValidationError") {{ $t('rateChallenge.errorMessage') }}

        div.c-form

            // Instructor Information
            v-textarea(
                name="information"
                :label="$t('fields.comment')"
                v-model="comment"
                outline
            )

        // footerText
        div.text-xs-center.mb-3 {{ $t('rateChallenge.footerText') }}

        div.text-xs-center

            // Set rating button
            button-component(
                    outline
                    color="white"
                    :action="submitRate"
                ) {{ $t('rateChallenge.buttonText') }}
</template>

<script>
    import starsSVG from './stars-svg.svg';
    import Button from '~components/Button';
    import { mapActions, mapGetters } from 'vuex';
    
    export default {
        components: {
            ButtonComponent: Button
        },
        data() {
            return {
                rating: 0,
                starsSVG,
                showValidationError: false,
                comment: ''
            };
        },
        computed: {
            starsWidth() {
                return {
                    width: `${100 - this.rating}%`
                };
            },
            ...mapGetters('auth', ['user'])
        },
        watch: {
            rating(val) {
                if (val) this.showValidationError = false;
            }
        },
        methods: {
            ...mapActions('users', ['setRating']),
    
            /**
             * Send rating and comment
             * @returns {*}
             */
            submitRate() {
                if (!this.rating) {
                    this.showValidationError = true;
                    return;
                }
                return this.setRating({
                    id: this.user.id,
                    rating: this.rating,
                    comment: this.comment
                });
            }
        }
    };
</script>

<style lang="stylus" scoped>
@import '../../../assets/style/_variables.styl'

.ratingWrapper
    width: 540px
    padding: 50px 0 20px
    display: flex
    align-items: center
    justify-content: center

.sliderWrapper
    position: relative
    padding: 100px 30px
    flex: 1 1 auto

.starsHideBlock
    overflow: hidden
    position: absolute
    right: 0
    top: -30px
    height: 150%
    background-color: $theme.primary

.slider
    margin-top: 20px
    width: 100%

.stars
    position: absolute
    width: calc(100% - 30px)
    top: -28px
    left: 30px

.ratingError
    text-align: center
    margin-bottom: 30px
    color: $theme.error

>>>
    .v-slider__thumb
        width: 46px
        height: 46px
        position: relative
        background: $theme.white
        border: 0px !important

        &:before
            content: ''
            width: 24px
            height: 24px
            position: absolute
            border-radius: 50%
            top: 11px
            left: 11px
            background-color: $theme.primary

@media screen and (max-width: 760px)
    .ratingWrapper
    .stars
        width: calc(100vw - 30px)

    .stars
        left: 0
        top: 17px

    .sliderWrapper
        padding: 50px 0

    .sliderLabel
        display: none
</style>
